import i18next from 'i18next'
import {initReactI18next} from 'react-i18next'
import VW from './translations/VW/translation.it.json'
import VI from './translations/VI/translation.it.json'

const options = {
    interpolation: {
        escapeValue: false,
    },
    debug: false,
    resources: {
        VW: {
            'fa-coupon': VW,
        },
        VI: {
            'fa-coupon': VI,
        },
    },
    fallbackLng: 'VW',
    defaultNS: 'fa-coupon',
    react: {
        bindI18n: 'languageChanged loaded',
        bindStore: 'added removed',
        transEmptyNodeValue: '',
        transSupportBasicHtmlNodes: true,
        transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
        useSuspense: true,
    },
}

i18next.use(initReactI18next).init(options)

export default i18next
